<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Enrollment"/>
        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Course" label-position="inside">
                        <b-select expanded v-model="enrollment.courseSelect" @change.native="changeCourse">
                            <option :value="c" v-for="c in courses">{{ c.name }}</option>
                        </b-select>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Custom Name" label-position="inside">
                        <b-input v-model="enrollment.customName" required></b-input>
                    </b-field>
                </div>
                <div class="column is-2">
                    <b-field label="Suffix" label-position="inside">
                        <b-select v-if="enrollment.courseSelect" expanded v-model="enrollment.custom1">
                            <option :value="c" v-for="c in enrollment.courseSelect.custom1">{{ c }}</option>
                        </b-select>
                        <b-select v-else disabled="true" expanded></b-select>
                    </b-field>
                </div>
                <div class="column is-2">
                    <b-field label="Suffix" label-position="inside">
                        <b-select v-if="enrollment.courseSelect" expanded v-model="enrollment.custom2">
                            <option :value="c" v-for="c in enrollment.courseSelect.custom2">{{ c }}</option>
                        </b-select>
                        <b-select v-else disabled="true" expanded></b-select>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Configuration" label-position="inside">
                        <b-select v-if="enrollment.courseSelect" expanded v-model="enrollment.configSelect" @change.native="changeConfig">
                            <option :value="c" v-for="c in enrollment.courseSelect.configurations">{{ c.units }} Clock Hours</option>
                        </b-select>
                        <b-select v-else disabled="true" expanded></b-select>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Total Clock Hours" label-position="inside">
                        <b-input v-model="enrollment.units" required></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="STEM Hours" label-position="inside">
                        <b-input v-model="enrollment.stem_units" required></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Other Hours" label-position="inside">
                        <b-input v-model="enrollment.other_units" required></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Notes" label-position="inside">
                        <b-input type="textarea" v-model="enrollment.adminnotes"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column is-4">
                    <b-field label="Cost" label-position="inside">
                        <b-input v-model="enrollment.totalPaid" required></b-input>
                    </b-field>
                </div>
                <div class="column is-4">
                    <b-field label="Plan ID" label-position="inside">
                        <b-input v-model="enrollment.planID" required></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>

        <subheader-list-item icon="fa-align-left" title="Flags"/>
        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field>
                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.completed"><strong>Completed</strong></b-switch>
                    </b-field>
                </div>
                <div class="column">
                    <b-field>
                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.surveycompleted"><strong>Survey Completed</strong></b-switch>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field>
                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.stem"><strong>Is STEM</strong></b-switch>
                    </b-field>
                </div>
                <div class="column">
                    <b-field>
                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.readonly"><strong>Read Only</strong></b-switch>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field>
                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.disabled"><strong>Course Level Disable</strong></b-switch>
                    </b-field>
                </div>
                <div class="column">
                    <b-field>
                        <b-switch :true-value="1" :false-value="0" v-model="enrollment.manualaward"><strong>Manual Award</strong></b-switch>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Enrollment Level Disable" label-position="inside">
                        <b-input type="textarea" v-model="enrollment.disabletext"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>

        <subheader-list-item icon="fa-align-left" title="Dates & Verification"/>
        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Enrollment Date" label-position="inside">
                        <b-datetimepicker position="is-bottom-left" append-to-body v-model="enrollment.enrollDate" expanded></b-datetimepicker>
                        <p class="control">
                            <b-button type="is-warning" outlined @click="enrollment.enrollDate = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                        </p>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Started Date" label-position="inside">
                        <b-datetimepicker position="is-bottom-left" append-to-body v-model="enrollment.startedDate" expanded></b-datetimepicker>
                        <p class="control">
                            <b-button type="is-warning" outlined @click="enrollment.startedDate = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                        </p>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Completed Date" label-position="inside">
                        <b-datetimepicker position="is-bottom-left" append-to-body v-model="enrollment.completedDate" expanded></b-datetimepicker>
                        <p class="control">
                            <b-button type="is-warning" outlined @click="enrollment.completedDate = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                        </p>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Expire Date" label-position="inside">
                        <b-datepicker position="is-bottom-left" append-to-body v-model="enrollment.expires_on" expanded></b-datepicker>
                        <p class="control">
                            <b-button type="is-warning" outlined @click="enrollment.expires_on = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                        </p>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Verify Date" label-position="inside">
                        <b-datetimepicker position="is-bottom-left" append-to-body v-model="enrollment.verifyDate" expanded></b-datetimepicker>
                        <p class="control">
                            <b-button type="is-warning" outlined @click="enrollment.verifyDate = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                        </p>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Verification Code" label-position="inside">
                        <b-input v-model="enrollment.verifyCode"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>

    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";

    import debounce from "debounce";

    import {client as http} from '../../http_client';

    export default {
        name: 'ClassicEnrollmentForm',
        props: {
            enrollment: {
                type: Object,
                required: true
            },
            card: {}
        },
        components: {CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                courses: []
            };
        },
        computed: {},
        methods: {
            changeCourse: function() {
                this.enrollment.configSelect = null;
                this.enrollment.customName = this.enrollment.courseSelect.customprefix;
                this.enrollment.startedDate = new Date();
            },
            changeConfig: function() {
                this.enrollment.units = this.enrollment.configSelect.units;
                this.enrollment.disabled = this.enrollment.configSelect.initialdisable;
            }
        },
        mounted: function() {
            http.get('courses').then(response => {
                this.courses = response.data;

                if (this.enrollment.id) {
                    for (let i = 0; i < this.courses.length; i++) {
                        const c = this.courses[i];
                        if (c.id === this.enrollment.course.id) {
                            this.enrollment.courseSelect = c;

                            for (let j = 0; j < c.configurations.length; j++) {
                                const config = c.configurations[j];
                                if (config.id === this.enrollment.config.id) {
                                    this.enrollment.configSelect = config;
                                    break;
                                }
                            }
                            // console.log(this.courseSelect, this.configSelect);
                            break;
                        }
                    }
                }

                this.$emit('loading', false);
            });
        }
    };

</script>
